export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "attribute": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atributo"])},
          "total": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valor"])},
          "legend": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Leyenda"])}
        }
      },
      "en": {
        "labels": {
          "attribute": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attribute"])},
          "total": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])},
          "legend": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Legend"])}
        }
      }
    }
  })
}